import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { Header } from "./components/layout/Header";
import { Footer } from "./components/layout/Footer";
import { Home } from "./pages/Home";
import { EventsList } from "./pages/EventsList";
import { EventsCalendar } from "./pages/EventsCalendar";
import { EventDetail } from "./pages/EventDetail";
import { Profile } from "./pages/Profile";
import { Basket } from "./pages/Basket";
import { CheckoutSuccess } from "./pages/CheckoutSuccess";
import { CheckoutCancel } from "./pages/CheckoutCancel";
import { Login } from "./pages/Login";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { Policies } from "./pages/Policies";
import { PolicyDetail } from "./pages/PolicyDetail";
import { NewsList } from "./pages/NewsList";
import { NewsArticle } from "./pages/NewsArticle";
import { Contact } from "./pages/Contact";
import { Downloads } from "./pages/Downloads";
import { Faqs } from "./pages/Faqs";
import { Gallery } from "./pages/Gallery";
import { Weather } from "./pages/Weather";
import { FindUs } from "./pages/FindUs";
import { Bookings } from "./pages/Bookings";
import { Pay } from "./pages/Pay";
import { PaySuccess } from "./pages/PaySuccess";
import { PayCancel } from "./pages/PayCancel";
import { BookingPaySuccess } from "./pages/BookingPaySuccess";
import { BookingPayCancel } from "./pages/BookingPayCancel";

function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <main className="flex-1 w-full">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route
            path="/*"
            element={
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 w-full">
                <Routes>
                  <Route path="/events" element={<EventsList />} />
                  <Route path="/events/calendar" element={<EventsCalendar />} />
                  <Route path="/events/:id" element={<EventDetail />} />
                  <Route path="/profile" element={<Profile />} />
                  <Route path="/bookings" element={<Bookings />} />
                  <Route path="/basket" element={<Basket />} />
                  <Route path="/checkout/success" element={<CheckoutSuccess />} />
                  <Route path="/checkout/cancel" element={<CheckoutCancel />} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/forgot-password" element={<ForgotPassword />} />
                  <Route path="/reset-password" element={<ResetPassword />} />
                  <Route path="/policies" element={<Policies />} />
                  <Route path="/policies/:slug" element={<PolicyDetail />} />
                  <Route path="/news" element={<NewsList />} />
                  <Route path="/news/:slug" element={<NewsArticle />} />
                  <Route path="/downloads" element={<Downloads />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/faqs" element={<Faqs />} />
                  <Route path="/weather" element={<Weather />} />
                  <Route path="/find_us" element={<FindUs />} />
                  <Route path="/contact_us" element={<Contact />} />
                  <Route path="/pay" element={<Pay />} />
                  <Route path="/pay/success" element={<PaySuccess />} />
                  <Route path="/pay/cancel" element={<PayCancel />} />
                  <Route
                    path="/booking-pay/success"
                    element={<BookingPaySuccess />}
                  />
                  <Route
                    path="/booking-pay/cancel"
                    element={<BookingPayCancel />}
                  />
                </Routes>
              </div>
            }
          />
        </Routes>
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
